import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query"

import { invalidationIntents } from "~/api/cache"

import type {
  UpdateProposalIncentiveStatusesDto,
  UpdateProposalIncentiveStatusesResponseDto,
} from "../dto/proposal-incentive.dto"
import { proposalIncentiveService } from "../services/proposal-incentive.service"

export type UpdateProposalIncentiveStatusesVariables = {
  proposalId: string
  data: UpdateProposalIncentiveStatusesDto
}

export default function useUpdateProposalIncentiveStatuses(): UseMutationResult<
  UpdateProposalIncentiveStatusesResponseDto,
  unknown,
  UpdateProposalIncentiveStatusesVariables
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      proposalId,
      data,
    }: UpdateProposalIncentiveStatusesVariables) =>
      proposalIncentiveService.updateStatuses(proposalId, data),
    onSuccess: (_data, { proposalId }) => {
      void invalidationIntents.proposalPricingInputsChanged(
        queryClient,
        proposalId,
      )
    },
  })
}
